import { useFormContext } from "react-hook-form"
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form"
import { InputFile } from "@/components/ui/input-file"
import { Tooltip } from "../ui/tooltip"

interface FormFileFieldProps {
  name: string
  label?: string
  placeholder?: string
  className?: string
  tooltipContent?: string
  disabled?: boolean
  onFileSelect?: (file: File | null) => void
  existingUrl?: string
}

export function FormFileField({
  name,
  label,
  placeholder,
  className,
  tooltipContent,
  disabled,
  onFileSelect,
  existingUrl,
}: FormFileFieldProps) {
  const { control } = useFormContext()

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          {label && (
            <FormLabel className="inline-flex gap-1 items-center text-gray-200 text-sm font-semibold">
              {label}
              {disabled && <Tooltip tooltipContent={tooltipContent ?? ""} align="end" />}
            </FormLabel>
          )}
          <FormControl>
            <InputFile
              field={field}
              placeholder={placeholder}
              onFileSelect={onFileSelect}
              disabled={disabled}
              existingUrl={existingUrl}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}